module.exports = __webpack_public_path__ + "img/order-payment.4e66bc71.png";